import { render, staticRenderFns } from "./PeopleMapMarker.vue?vue&type=template&id=6aab5a52&scoped=true&"
import script from "./PeopleMapMarker.vue?vue&type=script&lang=js&"
export * from "./PeopleMapMarker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aab5a52",
  null
  
)

export default component.exports